type Props = {
  features: string[];
};

export function SecurityFeatureList({ features }: Props) {
  return (
    <ul className="space-y-2">
      {features.map((f) => (
        <li key={f} className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-300">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success-100 text-xs text-success-700 dark:bg-success-950 dark:text-success-300" aria-hidden="true">
            ✓
          </span>
          {f}
        </li>
      ))}
    </ul>
  );
}
